
import React, { useState } from 'react';
import { InlineLoading } from 'carbon-components-react';
import { DashboardReference24, ScreenOff24, Hourglass24, Time24, CollapseAll24, WorkspaceImport24 } from '@carbon/icons-react';
import { CaretDown32 } from '@carbon/icons-react';
import { ReactComponent as UserAccess } from 'assets/image/UserAccess24.svg'

import * as DashboardConstants from '../../DashboardConstants'
require("./_summary.scss");

const Summary = (props) => {
    const summary = props.summary;

    function getIcon(icon) {
        switch (icon) {
            case 'Tile1': return < WorkspaceImport24 />;
            case 'Tile2': return <CollapseAll24 />;
            case 'Tile3': return <Time24 />;
            case 'Tile4': return <Hourglass24 />;
            case 'HumanError': return <UserAccess />;
            case 'MachineError': return <ScreenOff24 />;
            default: return <DashboardReference24 />;
        }
    }

    return (
        <div className="processes-summary">
            <div className="tile-container">
                <section className={props.direction === "column" ? "summary-tiles-container-column" : "summary-tiles-container"}>
                    {props.loading ?
                        <div className="tile loading-container">
                            <InlineLoading
                                description={DashboardConstants.Loading}
                            />
                        </div>
                        :
                        props.summary && props.summary.length ?
                            summary.map((type, index) => (
                                <div className="tiles" key={index}>
                                    <div className="title-container">
                                        <div>{getIcon(type.icon)}</div>
                                        <div className="tile-title carbon-display-Semibold-16">
                                            {type.title}
                                        </div>
                                    </div>
                                    <div className="value-container">
                                        <div className="tile-value carbon-display-Light-48">
                                            {type.value}
                                            {type.showHoursMinutes &&
                                                <div className="hours-minutes-container">
                                                    <div>{DashboardConstants.HoursLabel}</div>
                                                    <div>{DashboardConstants.Mins}</div>
                                                </div>}
                                        </div>
                                        {type.showOrders && type.orderValues &&
                                            <div className="order-container">
                                                <div className='order-column'><div>{DashboardConstants.Pending}:</div><div className='carbon-display-Semibold-18'>{type.orderValues.pending}</div></div>
                                                <div className='order-column'><div>{DashboardConstants.Exceptions}:</div><div className='carbon-display-Semibold-18'>{type.orderValues.exceptions}</div></div>
                                            </div>}

                                        <div className="percentage-container">
                                            {type.target && type.showPercent ? <div className="statusIndicator">
                                                {type.showArrow && <CaretDown32
                                                    style={{ height: '20px', width: '20px' }}
                                                />}
                                                {type.target}
                                            </div> : ''
                                            }
                                            {type.target && type.showPercent ?
                                                <div className="percent-wrapper">
                                                    %
                                                </div>
                                                :
                                                ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))
                            :
                            <div style={{ margin: '50px' }}>
                                {DashboardConstants.NoDataAvailable}
                            </div>
                    }
                </section>
            </div >
        </div >
    );
};

export default Summary;
